import { connect } from 'react-redux'
import MatrixView from '../../../../components/MatrixQuestion/MatrixView'
import { selectViewActions } from '../../modules/Survey'

export default connect(null, selectViewActions)(MatrixView)
